import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

/**
 * Redirects unauthenticated visitors to /login?next=<current path>.
 * Used to gate the product catalog and product detail pages so that
 * Stripe reviewers see a strict "must-register-to-view-inventory" flow —
 * matching the RUO buyer-qualification model.
 */
export default function RequireAuth({ children }) {
    const { user, checking } = useAuth();
    const location = useLocation();

    if (checking) {
        return (
            <div data-testid="auth-checking" className="pt-40 pb-24 bg-[var(--bg)] min-h-screen text-center">
                <p className="data-label text-muted">Verifying qualified access…</p>
            </div>
        );
    }

    if (!user) {
        const next = encodeURIComponent(location.pathname + location.search);
        return <Navigate to={`/login?next=${next}`} replace />;
    }

    return children;
}
